import styled from 'styled-components';

export const EmptyReportSection = styled.div`
  margin: 64px;
  padding: 120px 0;
  color: #aaa;
  text-align: center;
  border: 1px solid #dcdcdc;
`;
